<template>
  <div id="content"
       class="container detail-wrap">
    <div class="train-container booklist">
      <div v-for="(item, index) in bookList"
           :key="item.id"
           class="book"
           :class="index%4==0? 'course-margin' :''">
        <div class="course-img">
          <img :src="item.url?item.url:imgUrl"
               :alt="item.bookName"
               width="280px"
               height="194px" />
          <!--  @click="" -->
        </div>
        <div class="course-name">
          <h3 class="overell">{{item.bookName}}</h3>
        </div>
        <div class="course-info">
          <div>
            <span>{{item.viewCount || 0}}人学习</span>
            &nbsp;| &nbsp;
            <span>{{item.viewCount || 0}}浏览</span>
          </div>
          <div>
            <span class="course-info-price">￥{{item.bookPrice}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bookList: this.list,
      imgUrl: '../../../../../static/img/占位图_en.png',
      booklist: [
        {
          name: '2020年培训计划',
          imgurl: 'https://i-learning.supcon.com/group1/M00/00/02/CgoBG1wPO96AKIg5AABA-ywBnwg840.jpg'
        },
        {
          name: '2020年培训计划',
          imgurl: 'https://i-learning.supcon.com/group1/M00/00/02/CgoBGVwI4jiAcaV8AACWupOtyXw513.jpg'
        },
        {
          name: '2020年培训计划',
          imgurl: 'https://i-learning.supcon.com/group1/M00/00/02/CgoBG1wPO96AKIg5AABA-ywBnwg840.jpg'
        },
        {
          name: '2020年培训计划',
          imgurl: 'https://i-learning.supcon.com/group1/M00/00/02/CgoBGVwI4jiAcaV8AACWupOtyXw513.jpg'
        },
        {
          name: '2020年培训计划',
          imgurl: 'https://i-learning.supcon.com/group1/M00/00/02/CgoBG1wPO96AKIg5AABA-ywBnwg840.jpg'
        },
        {
          name: '2020年培训计划',
          imgurl: 'https://i-learning.supcon.com/group1/M00/00/02/CgoBGVwI4jiAcaV8AACWupOtyXw513.jpg'
        }
      ]
    }
  },
  props: ['list'],
  mounted () {
    console.log(this.list)
  }
}
</script>
<style scoped>
.booklist {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.book {
  width: 280px;
  margin-left: 22px;
  margin-bottom: 40px;
}
.detail-wrap {
  margin-top: 30px;
}
.book img {
  width: 100%;
  height: 150px;
}
.course-margin {
  margin-left: 0px;
}
.course-img {
  cursor: pointer;
}
.course-name {
  margin-top: 10px;
}
.course-name h3 {
  font-size: 18px;
  font-weight: normal;
  cursor: pointer;
}
.course-info {
  line-height: 20px;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.course-info-price {
  /* display: inline-block; */
  padding: 1px 12px;
  text-align: center;
  height: 20px;
  font-size: 14px;
  color: #fff;
  background-color: #009ed9;
}
</style>
